import { alertConstants,userConstants } from '../_constants';

export function alert(state = {}, action) {
  switch (action.type) {
    case alertConstants.SUCCESS:
      return {
        clase: 'bg-success',
        type: 'success',
        message: action.error.message?action.error.message:action.error,
        codigo: action.error.codigo?action.error.codigo:''
      };
    case alertConstants.ERROR:
      return {
        clase: 'bg-danger',
        type: 'error',
        message: action.error.message,
        codigo: action.error.codigo
      };
    case alertConstants.CLEAR:
      return {};
    default:
      return state
  }
}